import { Rectangle, Circle } from './elements.js';
import { List } from './layouts/list.js';
import { Paragraph } from './layouts/paragraph.js';
import { Text } from './layouts/text.js';

var Skeleton = {
  Text: Text,
  List: List,
  Paragraph: Paragraph,
  Rectangle: Rectangle,
  Circle: Circle
};

export { Skeleton };
